import FileEncryptDecrypt from '../components/file-encryption-decryption-v1';
import '../css/App.css';

function App() {
  return (
    <>
      <FileEncryptDecrypt />
    </>
  );
}

export default App;
